import React from 'react';
import { RouteType } from '../types';
import { CvLayout } from '../../../Pages/CV/cvLayout';
import { CvContainer } from '../../../Pages/CV/cvContainer';
import { ProjectOverviewContainer } from '../../../Pages/ProjectOverview/ProjectOverviewContainer';
import { ProjectOverviewLayout } from '../../../Pages/ProjectOverview/ProjectOverviewLayout';

export const routes: Array<RouteType> = [
	{
		path: '/cv/',
		element: <CvContainer Layout={CvLayout} />,
	},
	{
		path: '/projectOverview/',
		element: <ProjectOverviewContainer Layout={ProjectOverviewLayout} />,
	},
];
